import React, { Component } from "react";
import HeaderNavBar from "../HeaderNavBar/HeaderNavBar";
import ScrolltoTop from "../ScrollTop/ScrollTop";
import Footer from "../Footerpage/Footer";
import CMSTranslationFile from "../Footerpage/Credits_Translation_Corp.json";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import "./Credits.css";
import TranslationFile from "../Translation/Translation_corp.json";
import { Helmet } from "react-helmet";

let userSelectedLanguage;

class Credits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      creditList: []
    };
  }

  scrollToContactUs() {
    this.props.callBack();
  }

  componentWillMount() {
    userSelectedLanguage = localStorage.getItem("selectedLanguage");
    window.scrollTo(0, 0);

    this.setState({
      creditList: [
        {
          name: CMSTranslationFile.Credits_FirstImage_title[
            userSelectedLanguage
          ],
          url: "https://www.freepik.com/free-photo/blue-print-with-laptop-copy-space_6413502.htm"
        },

        {
          name: CMSTranslationFile.Credits_SecondImage_title[
            userSelectedLanguage
          ],
          url: "https://www.freepik.com/free-photo/woman-working-with-finances-table-laptop-smartphone-money-notepad_14203171.htm"
        },

        {
          name: CMSTranslationFile.Credits_SIE_Processing_Gif[
            userSelectedLanguage
          ],
          url: "https://www.flaticon.com/free-animated-icons/process"
        },

        {
          name: CMSTranslationFile.Preview_PDF_Loading_Gif[
            userSelectedLanguage
          ],
          url: "https://www.flaticon.com/free-animated-icons/pdf"
        },

        {
          name: "Invoice animated icons",
          url: "https://www.flaticon.com/free-animated-icons/invoice"
        },

        {
          name: "Declined animated icons",
          url: "https://www.flaticon.com/free-animated-icons/declined"
        },

        {
          name: "Approval animated icons",
          url: "https://www.flaticon.com/free-animated-icons/approval"
        },

        {
          name: "Businessmen hands on white table with documents and drafts",
          url: "https://www.freepik.com/free-photo/businessmen-hands-white-table-with-documents-drafts_7514916.htm"
        },

        {
          name: "Hand drawn remote recruitment illustration",
          url: "https://www.freepik.com/free-vector/hand-drawn-remote-recruitment-illustration_79310663.htm"
        },

        {
          name: "Mini people with bulb light idea",
          url: "https://www.freepik.com/free-vector/mini-people-with-bulb-light-idea_5713888.htm"
        },

        {
          name: "Unlock secure 4 pin password",
          url: "https://www.magnific.com/free-photo/computer-security-with-login-password-padlock_34131578.htm#fromView=keyword&page=1&position=0&uuid=40942bcc-1908-41b1-aae8-71e8c378661d&query=Unlock+secure+4+pin+password+png"
        },
        {
          name: "Online survey 3d render laptop form with ticks",
          url: "https://www.magnific.com/free-photo/online-survey-3d-render-laptop-form-with-ticks_33525390.htm#fromView=search&page=1&position=8&uuid=3d644411-89fe-4fd5-9cba-550f08fb6010&track=ais_hybrid&query=forms+and+laptop+animation"
        }
      ]
    });
  }

  callback = () => {
    this.setState({
      reRender: true
    });
  };

  render() {
    const { creditList } = this.state;

    console.log(creditList, ">");
    if (userSelectedLanguage == null) {
      userSelectedLanguage = "sw";
    }

    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            {userSelectedLanguage == "sw"
              ? TranslationFile.FaviconAppText[userSelectedLanguage]
              : TranslationFile.FaviconAppText.en}
          </title>
        </Helmet>

        <HeaderNavBar isCorpPortal={true} />
        <div className="credits-div">
          <br></br>
          <br></br>
          <div
            style={{
              // fontWeight: 700,
              // fontSize: "30px",
              textAlign: "center"
            }}
          >
            {/* Credits */}
            <strong>
              {CMSTranslationFile.Credits_Heading[userSelectedLanguage]}
            </strong>
          </div>
          <br></br>

          <div>
            <section
            // style={{
            //   fontSize: "25px",
            //   fontWeight: "800",
            // }}
            >
              {/* Images : */}
              <strong>
                {CMSTranslationFile.Credits_Images_title[userSelectedLanguage]}
              </strong>
            </section>
            <section
            // style={{
            //   fontSize: "20px",
            //   fontWeight: "750",
            // }}
            >
              {/* Freepik : */}
              <strong>
                {CMSTranslationFile.Credits_Freepik_title[userSelectedLanguage]}
              </strong>
            </section>
            <br></br>
            <br></br>

            {creditList &&
              creditList.length > 0 &&
              creditList.map((i, idx) => {
                return (
                  <div>
                    <div>
                      {idx + 1} . {i.name}
                    </div>
                    <div>
                      <a href={i.url} target="blank">
                        {i.url}
                      </a>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
        <ScrolltoTop />
        <Footer />
      </div>
    );
  }
}

export default Credits;
